__turbopack_context__.v({
  "content": "ReviewCard-module-scss-module__t0gJNq__content",
  "image-wrapper": "ReviewCard-module-scss-module__t0gJNq__image-wrapper",
  "rating": "ReviewCard-module-scss-module__t0gJNq__rating",
  "rating-icon": "ReviewCard-module-scss-module__t0gJNq__rating-icon",
  "review-card": "ReviewCard-module-scss-module__t0gJNq__review-card",
});
